export default {"src":"/_next/static/media/apple.eeac5851.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};